var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filePreciewBox"},[(!_vm.isPDF)?_c('div',{staticClass:"notPdf"}):_vm._e(),_c('iframe',{attrs:{"src":_vm.showFileSrc,"width":"100%","height":"100%","id":"box","frameborder":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }